export default class ComparisonSliderAnimation {
  constructor(containerWdith, sliderStartPos) {
    this._containerWidth = containerWdith
    this._sliderStartPosition = sliderStartPos
    this._moveElements = document.querySelectorAll('.comparison-images-slider__decorator--move')
    this.setSlidePosition(sliderStartPos)
  }

  setSlidePosition(posX) {
    const calculatedPos = (posX / this._containerWidth) * 100
    this.setMoveElementPos(calculatedPos)
  }

  setMoveElementPos(pos) {
    this._moveElements.forEach(el => {
      el.querySelector('img').style.transform = `translateX(${pos}px)`
    })
  }
}
